import React from "react";
import { newID } from "../utils/unique";

export function useRefresh() {
    const [token, setToken] = React.useState("");

    function refresh() {
        setToken(newID());
    }

    return {
        refresh,
        token,
    }
}